import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import {
   DirectoryData,
   DirectoryValueEntry,
} from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.selectors';

@Pipe({
   name: 'availableDirectoryDataForColumn',
})
export class AvailableDirectoryDataForColumnPipe implements PipeTransform {
   constructor() {}

   transform(dataItems: DirectoryData[] | Observable<DirectoryData[]>, column: DirectoryColumn): Observable<DirectoryValueEntry[]> {
      let dataItems$: Observable<DirectoryData[]>;
      if (isObservable(dataItems)) {
         dataItems$ = dataItems;
      } else {
         dataItems$ = of(dataItems);
      }
      return dataItems$.pipe(map((directoryData) => directoryData.find((dataItem) => _.isEqual(dataItem.column, column))?.entries));
   }
}
